class GusService {
    static getDataByNip(url, nip) {
        return $.ajax({
            url: url,
            method: "post",
            data: {nip: nip},
            dataType: "json",
        });
    }
}

export default GusService;


// WEBPACK FOOTER //
// ./assets/js/utils/gus-service.js